import React, { useState, useCallback } from 'react';
import { Dialog, TextField } from '@framework-controls/core';
import { strings } from 'src/localization';
import { IconRemove } from 'src/content/icons';
import css from './SkipLightBox.module.scss';
import SVPButton from '../../SVPButtons/SVPButton';
import { VehicleRecs, ascCtaInteractionInput, ascFormEngagementInput, ascElementConfigurationInput } from 'src/models';
import { ascCtaInteraction, ascFormEngagement, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';

export interface IProps {
    proceed: (reason: string) => void;
    cancel: (e: any) => void;
    specSkipMsg?: string;
    dialogOpen?: boolean;
    theme: string;
    selectedVehicle?: string;
    vehicles: VehicleRecs;
}

const SkipLightBox = (props: IProps) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState(true);

    const changeHandler = useCallback((id: string, value: string) => {
        setReason(value);
        if (value.length > 0 && /\S/.test(value)) {
            setError(false);
        } else {
            setError(true);
        }
    }, []);

    const headerBoxStyles = classNames(
        css.headerbox,
        {
            [css.headerboxMazda]: props.theme === 'mazda',
            [css.headerboxGenesis]: props.theme === 'genesis',
        },
    );

    const buttonHandler = useCallback((e: any) => {
        props.proceed(reason);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Proceed,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.Proceed,
            elementType: 'scheduling_tool',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
    }, [props.proceed, reason, props.vehicles, props.selectedVehicle]);

    const blurHandler = useCallback(() => {
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'item',
            commType: 'form',
            commStatus: 'engage',
            elementText: strings.EmptyFieldError,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp);
    }, []);
    // let headerClass = css.headerbox;
    // if (props.theme === 'volkswagen') {
    //     headerClass = css.headerboxVW;
    // }

    // Field Validation

    // The following comments are for future branches of the proceed button based on state variables

    // const proceedHandler = (event) => {
    // event.preventDefault();
    // if a previous customer we go to the Calendar default screen

    // if not a previous customer, go to Calendar select page

    // Both: a labor line called 'Bring vehicle in for appointment' auto added to their appointment
    // This zero price operation will be linked to a DMS operation code assigned in the Specs screen for Service Portal

    // When the operation is added to the appointment,
    // the entry in the lightbox will be added as the Complaint statement on the job

    // Notification
    // There will be an option in the Service Specs screen that controls whether to send a notification to a user or group
    // when an appointment is created using this method.
    // The notification will also contain the contents of the Skip Services lightbox
    // };

    return (
        <Dialog
            isOpen={props.dialogOpen!}
            header={strings.ReasonForVisit}
            cssClasses={{
                content: css.content,
                paper: css.paper,
                header: css.LightBoxHeader,
            }}

            width={'full'}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            onBackDropClick={props.cancel}
            hideClose
            hideSave
            hideCancel
            onCancel={props.cancel}
        >
            <div>
                <div className={headerBoxStyles}>
                    {strings.ReasonForVisit}
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={props.cancel}/>
                    </div>
                </div>
                <div className={css.header}>
                    <h4 id='h4LightBox'>{props.specSkipMsg}</h4>
                </div>
                {/* <div>{props.specSkipMsg}</div> */}
                <div className={error ? css.inputError : css.input}>
                    <TextField
                        id='Reason'
                        label=''
                        onChange={changeHandler}
                        onBlur={blurHandler}
                        value={/\S/.test(reason) ? reason : ''}
                        type='text'
                        size='full'
                        helperText=''
                        multiline
                        rows={5}
                        error={error}
                        border = {error ? false : true}
                        disableUnderline = {true}
                        hint={strings.EmptyFieldError}
                    />
                </div>
                <hr className={css.hr}/>
                <div className={css.btnArea}>
                    <div className={css.btn}>
                        <SVPButton
                            id='Proceed'
                            handler={buttonHandler}
                            message={strings.Proceed}
                            isDisabled={error}
                            noArrow
                            variant={'primaryBtn'}
                            tooltip={strings.ProceedTip}
                            theme={props.theme}
                        />
                    </div>
                    <div className={css.btn}>
                        <SVPButton
                            id='Cancel'
                            handler={props.cancel}
                            message={strings.Cancel}
                            variant={'secondaryBtnAlt'}
                            noArrow
                            theme={props.theme}/>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default SkipLightBox;